import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import WhyAttend from './components/WhyAttend';
import EventDetails from './components/EventDetails';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Features />
      <WhyAttend />
      <EventDetails />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
